import Blink from '@components/Blink'
import SvgIcon from '@components/SvgIcon'
import { FunctionComponent, useCallback } from 'react'
import styled, { css, useTheme } from 'styled-components'
import config from '@config'
import useHeaderSearchBar from '@hooks/useHeaderSearchBar'
import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import useIsImmersiveHeaderActive from '@hooks/useIsImmersiveHeaderActive'

const {
  leserreporter: { leserreporterPageUrl },
} = config

const StyledLink = styled(Blink)<{ isLinkVisible: boolean }>`
  ${({
    theme: {
      colors: { iconBrand },
    },
    isLinkVisible,
  }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    appearance: none;
    text-decoration: none;
    user-select: none;

    width: 48px;
    height: 48px;

    user-select: none;

    transition: width 0.2s ease-in-out;

    ${desktopCSS(css`
      width: 40px;
      height: 40px;
    `)}

    ${isLinkVisible &&
    css`
      ${desktopCSS(css`
        width: 0;
      `)}
    `}

    &:hover {
      svg {
        fill: ${iconBrand};
      }
    }
  `}
`

const StyledSvgIcon = styled(SvgIcon)<{ isImmersiveHeaderActive: boolean }>`
  ${({
    theme: {
      colors: { staticWhite },
    },
    isImmersiveHeaderActive,
  }) => css`
    ${isImmersiveHeaderActive &&
    css`
      ${mobileAndTabletCSS(css`
        fill: ${staticWhite};
      `)}
    `}
  `}
`

const LeserreporterLink: FunctionComponent = () => {
  const theme = useTheme()
  const isImmersiveHeaderActive = useIsImmersiveHeaderActive()
  const { isSearchBarCollapsed } = useHeaderSearchBar()

  const trackingOnClick = useCallback<TrackingFnType>(
    () => ({
      event: 'leserreporter_lp_click',
      button_label: 'Leserreporter',
    }),
    []
  )

  const handleTrack = useTracking(trackingOnClick)

  return (
    <StyledLink
      isLinkVisible={!isSearchBarCollapsed}
      href={leserreporterPageUrl}
      onClick={handleTrack}
      ariaLabel="Leserreporter">
      <StyledSvgIcon
        iconName="camera"
        size={24}
        color={theme.colors.iconDefault}
        isImmersiveHeaderActive={isImmersiveHeaderActive}
      />
    </StyledLink>
  )
}

export default LeserreporterLink
